import { headerHeight } from "@remo-co/ui-core/src/constants";
import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme, { isMobile: boolean }>((theme) => ({
  wrapper: {
    border: `1px solid ${theme.palette.gray.muted1}`,
    borderRadius: 5,
  },
  loading: {
    padding: theme.spacing(1.5),
  },
  loaderIcon: {
    marginRight: theme.spacing(2),
  },
  expand: {
    cursor: "pointer",
    textAlign: "center",
    color: theme.palette.present.greyBackground,
    padding: theme.spacing(1.5),
  },
  retryButton: {
    color: theme.palette.present.greyBackground,
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  retryIcon: {
    marginRight: theme.spacing(1),
  },
  status: {
    padding: theme.spacing(1.5),
  },
  supportedStatus: {
    padding: theme.spacing(3),
    height: "calc(100% - 47px)",
    flexDirection: "column",
  },
  failedStatusText: {
    color: theme.palette.error.dark,
  },
  successfulStatusText: {
    color: theme.palette.success.dark,
  },
  results: {
    height: `calc(40vh -  ${headerHeight}px - ${theme.spacing(
      2,
    )} - ${theme.spacing(6)})`, // header height + mic cam container top and bottom padding
    minHeight: "300px",
    overflowY: "scroll",
  },
  subheading: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(2.5),
    textAlign: "center",
  },
}));
